import { ReactElement } from "react";
import { Typography } from "@/shared/ui/Typography";
import { BRAND_TEXT_PRIMARY, BRAND_TEXT_SECONDARY } from "@/styles/colorsJS";

type FeatureCardTag = "div" | "li";

export interface FeatureCardProps {
  Icon: ReactElement;
  title: ReactElement;
  text: ReactElement;
  key?: string;
}

type Props<T extends FeatureCardTag> = {
  as?: T;
} & FeatureCardProps;

export function FeatureCard({ Icon, title, text, as }: Props<FeatureCardTag>) {
  const Tag = as ?? "div";
  return (
    <Tag className="bg-brand-bg-saturated rounded-2xl px-6 py-4">
      {Icon}
      <Typography
        as="h5"
        type="title"
        className="mt-4"
        color={BRAND_TEXT_PRIMARY}
      >
        {title}
      </Typography>
      <Typography as="p" className="mt-2" color={BRAND_TEXT_SECONDARY}>
        {text}
      </Typography>
    </Tag>
  );
}
